import { render } from "./EditCoursePage.vue?vue&type=template&id=0e2a087c&ts=true"
import script from "./EditCoursePage.vue?vue&type=script&lang=ts"
export * from "./EditCoursePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__